<template>
  <v-row class="about text-center py-3 my-12" no-gutters>
    <v-col md="6" offset-md="3" class="px-3 px-md-0">
      <h3 class="text-h5 text-md-h4 font-weight-medium text-uppercase">Présentation</h3>
      <p>Auteur photographe Breton, et pilote de drone agréé</p>
      <p>Proche de la nature et passionné par le patrimoine, mes sujets photographiques me viennent alors tout naturellement : paysages et animalier essentiellement.
      Vivant dans une région qui regorge de tous ces trésors, j'en profite pour capturer quelques belles images de cette nature superbe qui m'entoure, avec toujours l'idée de mettre en valeur ma région.
      Amoureux du centre Bretagne, de ses paysages, de sa nature, ses lumières, sa faune et sa flore, sont toujours pour moi une source d'émerveillement.
      C'est pour cela que mon terrain de jeu se situe la plupart du temps en "terres bretonnes".
      Le centre Bretagne, est pour moi synonyme d'une grande culture, d'une histoire, d'un patrimoine et d'une nature exceptionnelle...
      Toutes ces choses qui me sont chères et que j'essaie d'immortaliser avec mon regard de photographe.</p>
      <p>J'espère que vous aurez autant de plaisir à admirer mes photos, que j'en ai eu à les faire !</p>
      <v-img :src="yh" alt="Yohann Hamonic" class="mt-12"></v-img>
    </v-col>
  </v-row>
</template>

<script>
import yh from "@/assets/yh.webp"
export default {
  name: "aboutMe",
  data: () => ({
    yh: yh
  })
};
</script>

<style scoped>
.about {
  background: #fefefe;
}
</style>